import { Type } from "../../domain";
import { EndpointType } from "../BaseEndpoint";

/** `CreatedT` : pour les ressources dont la création répond autre chose que la ressource complète. */
export interface WithCreateType<T, CreateT, CreatedT = T> {
  create(
    body: CreateT,
    options?: {
      showErrorModal?: boolean;
    },
  ): Promise<CreatedT>;
}

export const WithCreate = <EndpointT extends EndpointType, T, CreateT = T, CreatedT = T>(
  clazz: EndpointT,
): Type<WithCreateType<T, CreateT, CreatedT>> & EndpointT =>
  class extends clazz {
    /**
     * Create a new resource
     *
     * @param body Payload used to create the new resource
     */
    create(
      body: CreateT,
      options?: {
        showErrorModal?: boolean;
      },
    ): Promise<CreatedT> {
      return this.request("", {
        method: "POST",
        body,
        ...options,
      });
    }
  };
